import * as THREE from 'three'
import React, { useMemo, useState } from 'react'

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { MaterialTrim, MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {
    const [sideWallCloseSize, setSideWallCloseSize] = useState(0);

    const wallThickness = 0.005
    const backWallVrTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(params.leanR_p_d / 2, 0);
        model.lineTo(params.leanR_p_d / 2, sideWallCloseSize);
        model.lineTo(params.leanR_p_d / 2 + 0.26, sideWallCloseSize);
        model.lineTo(params.leanR_p_d / 2 + 0.26, 0);
        model.closePath();
          
        return model;
    }, [params.add_storage_check_right, params.p_b_c_b_r_b, params.add_right_back_lean_porch, params.leanR_p_h, params.leanR_p_d, params.p_b_c_b_r, sideWallCloseSize])

    const storageBackWall = useMemo(() => {

        let wainscot, trim;

        /**********************cutting hole using CSG for Back************************/ 
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanSide', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'green' }))
        const meshBackDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('rightLeanStorageBack', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'red' }));
        const meshTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(backWallVrTrimModel, extrudeSettings(0.22)));

        let meshSideDelModel_Temp = meshSideDelModel.clone();
        meshSideDelModel_Temp.position.set(params.rightLeanStoragePosition, 0, -0.1 - params.leanR_p_pos);
        meshSideDelModel_Temp.updateMatrixWorld();

        let meshBackDelModel_Temp = meshBackDelModel.clone();
        meshBackDelModel_Temp.position.set((params.leanR_p_d / 2 + 0.5), 0, -(params.p_w / 2 + params.leanR_p_w - 0.185 + wallThickness))
        meshBackDelModel_Temp.rotation.y = -Math.PI / 2
        meshBackDelModel_Temp.updateMatrixWorld();

        let meshTrimModel_Temp = meshTrimModel.clone();
        // meshTrimModel_Temp.position.set(-parseInt(params.add_storage) - 0.1 - offset, 0, -0.02)
        meshTrimModel_Temp.updateMatrixWorld();

        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp);
        const meshBackDelModel_CSG = CSG.fromMesh(meshBackDelModel_Temp);
        const meshTrimModel_CSG = CSG.fromMesh(meshTrimModel_Temp);

        const meshBackWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.leanR_p_w + 0.01)))
        let meshBackWainscotModel_Temp = meshBackWainscotModel.clone();
        meshBackWainscotModel_Temp.position.set((params.leanR_p_d / 2 + 0.1525) + 0.03, 3 , -(params.leanR_p_w) + 0.098)
        meshBackWainscotModel_Temp.updateMatrixWorld();

        const meshBackWainscotModel_CSG = CSG.fromMesh(meshBackWainscotModel_Temp);
 
        const backWainscotSideDelModel_CSG = meshBackWainscotModel_CSG.subtract(meshSideDelModel_CSG);
        const backWainscotTrimDelModel_CSG = backWainscotSideDelModel_CSG.subtract(meshBackDelModel_CSG);
        const meshTrimDelModel_CSG = meshTrimModel_CSG.subtract(meshSideDelModel_CSG);

         const CSGWainscotTrimBackModel = CSG.toMesh(backWainscotTrimDelModel_CSG,new THREE.Matrix4())
         const meshTrimDelModel = CSG.toMesh(meshTrimDelModel_CSG, new THREE.Matrix4());

        wainscot = CSGWainscotTrimBackModel.geometry;
        trim = meshTrimDelModel.geometry;
 
        return {wainscot, trim};

        }, [params.leanR_p_w, params.leanR_p_d, params.p_w, const_var.newDoorsArray, params.leanR_p_pos, params.rightLeanStoragePosition, backWallVrTrimModel])

    // --- side wall set    
    useMemo(() => {
        let tempWallCloseSize = 0;
        if (params.p_b_c_b_r === 'Open' || typeof(params.p_b_c_b_r) === 'object') {
            if (params.p_r_s === 1) {
                tempWallCloseSize = params.leanR_p_h + 0.15;
            } else {
                tempWallCloseSize = params.leanR_p_h;
            }
        } else if (params.p_b_c_b_r === "One_Fourth_Close") {
            tempWallCloseSize = params.leanR_p_h / 4 * 3;
        } else if (params.p_b_c_b_r === "Half_Close") {
            tempWallCloseSize = params.leanR_p_h / 2;
        } else if (params.p_b_c_b_r === "Three_Fourth_Close") {
            tempWallCloseSize = params.leanR_p_h / 4;
        } else if (params.p_b_c_b_r === "Close") {
            tempWallCloseSize = 0;
        } else {
            tempWallCloseSize = params.leanR_p_h - 3 * params.p_b_c_b_r;
        }

        setSideWallCloseSize(tempWallCloseSize);
    }, [params.p_b_c_b_r, params.leanR_p_h, params.p_r_s])


    return (
        <group position={[(params.p_w / 2 + params.leanR_p_w - 0.185 + wallThickness), 0, 0]} rotation={[0, Math.PI / 2, 0]}>
            <mesh name="back-wall-trim" geometry={storageBackWall.trim}>
                <MaterialTrim visibleSection={"rightLean"} />
            </mesh>

            {params.p_w_c_n == true &&
                <mesh name="wainscotTrim" geometry={storageBackWall.wainscot} >
                    <MaterialWainScotTrimNew visibleSection={"rightlean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel